import type { RawTypedNativeModules, TypedNativeModules } from "../types/NativeModulesTypes";

type BridgeMethodProxyHandler = ProxyHandler<
  Required<RawTypedNativeModules>[keyof Required<RawTypedNativeModules>]
>;

const bridgeProxies: Map<string, TypedNativeModules[keyof TypedNativeModules]> = new Map();

const bridgeProxyHandler: ProxyHandler<RawTypedNativeModules> = {
  get(target, prop) {
    // Regenerator runtime may check if this object is a thenable
    if (prop === "then") {
      return undefined;
    }
    if (typeof prop !== "string") {
      return undefined;
    }
    const bridge = target[prop as keyof typeof target] ?? {};
    if (!bridgeProxies.has(prop)) {
      bridgeProxies.set(
        prop,
        new Proxy(bridge, bridgeMethodProxyHandler) as TypedNativeModules[keyof TypedNativeModules],
      );
    }
    return bridgeProxies.get(prop);
  },
};

const bridgeMethodProxyHandler: BridgeMethodProxyHandler = {
  get(target, prop) {
    // Regenerator runtime may check if this object is a thenable
    if (prop === "then") {
      return undefined;
    }

    const method = target[prop as keyof typeof target];

    if (method === undefined) {
      return typeof prop === "string" && prop.endsWith("Sync")
        ? () => null
        : () => {
            return Promise.resolve(null);
          };
    }

    return method;
  },
};

export function proxyBridges(bridges: RawTypedNativeModules): TypedNativeModules {
  return new Proxy(bridges, bridgeProxyHandler) as TypedNativeModules;
}

export function __resetProxiesForTestEnvironment() {
  bridgeProxies.clear();
}
